import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

DialogEditSettingView.propTypes = {
    item: PropTypes.object,
    name: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    unit: PropTypes.string,
    isDropdown: PropTypes.bool,
    isRequired: PropTypes.bool,
    hasManyInput: PropTypes.bool,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogEditSettingView({ item, name, title, label, unit, isDropdown = true, isRequired = true, hasManyInput = false, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('');

    useEffect(() => {
        if (!item || name === undefined) {
            setValue(hasManyInput ? [] : '');
            return;
        }
        const data = item[name];
        if (hasManyInput) {
            setValue(Array.isArray(data) ? data : []);
        } else {
            setValue(!!data ? data : '');
        }
    }, [item, name, hasManyInput]);

    // MARK: ---- METHODS ----
    const handleSubmit = async () => {
        if (name === 'productVatRate') {
            const percent = Number(String(value).replace(',', '.'));
            if (String(value).trim() === '' || !Number.isFinite(percent) || percent < 0 || percent > 100) {
                ToastHelper.showError('Thuế suất VAT phải là số từ 0 đến 100');
                return;
            }
        } else if (isRequired && !Utils.isValid(value)) {
            ToastHelper.showError('Vui lòng điền đủ thông tin');
            return;
        }
        if (isRequired && hasManyInput) {
            const isInvalid =
                !Array.isArray(value) ||
                value.length === 0 ||
                value.some(item => !item?.value?.toString().trim());

            if (isInvalid) {
                ToastHelper.showError('Vui lòng điền đủ thông tin');
                return;
            }
        }
        setLoading(true);
        const payload = {
            key: name,
            value: hasManyInput
                ? JSON.stringify(value)
                : (name === 'productVatRate' && String(value).trim() !== '' && Number(value) === 0)
                    ? '0' // VAT 0% là giá trị hợp lệ — không được coi là "xóa cấu hình"
                    : !!value
                        ? value
                        : null,
            description: `${title}${unit ? ` (${unit.toLowerCase()})` : ''}`
        };
        miscHelper.callApiUpdateConfig(payload)
            .then((res) => {
                ToastHelper.showSuccess('Cài đặt thành công');
                if (onDone) onDone();
            })
            .catch((error) => {
                ToastHelper.showError('Có lỗi xảy ra');
            })
            .finally(() => {
                setLoading(false);
            });
        return;
    };

    const options = [
        { name: 'Có', value: 1 },
        { name: 'Không', value: 0 },
    ]

    return (
        <div>
            {!hasManyInput
                ? (
                    <div className="p-4">
                        {UIHelper.buildFormLabel(title, isRequired)}
                        {isDropdown
                            ? (
                                <KTBSDropdown
                                    name="value"
                                    toggleElement={
                                        <button
                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                            type="button"
                                        >
                                            {_.find(
                                                options,
                                                (item) => item.value === value
                                            )?.name ?? 'Chọn lựa chọn'}
                                        </button>
                                    }
                                    selectedValue={value}
                                    dropdownMenuItems={options}
                                    dropdownMenuClassName="overflow-auto w-100"
                                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                                    onChange={(value) => {
                                        setValue(value);
                                    }}
                                    isDropdownForm={true}
                                />
                            ) : (
                                <div className='d-flex gap-2 align-items-center'>
                                    <div style={{
                                        whiteSpace: 'nowrap',
                                        ...UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])
                                    }}>{label}</div>
                                    <KTFormInput
                                        type={KTFormInputType.currency}
                                        unit={unit}
                                        placeholder="Nhập số"
                                        name={name}
                                        value={value}
                                        onChange={(value) => {
                                            setValue(value);
                                        }}
                                    />
                                </div>
                            )}
                    </div>
                ) : (
                    <div className='p-4'>
                        <div style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}>
                            Thời gian thông báo khi không có người nhận công việc bảo trì sửa chữa kể từ lúc phân phối theo độ ưu tiên
                        </div>
                        <div className='row px-2 mt-2'>
                            {Array.isArray(value) && value?.map((item, index) => (
                                <div key={index} className='col-6 px-2 mb-2'>
                                    {UIHelper.buildFormLabel(item?.name, true)}
                                    <KTFormInput
                                        type={KTFormInputType.currency}
                                        unit="Phút"
                                        placeholder="Nhập số"
                                        name={item?.name}
                                        value={item?.value}
                                        onChange={(newVal) => {
                                            setValue((prev) => {
                                                const newArr = [...(prev ?? [])];
                                                newArr[index] = {
                                                    ...newArr[index],
                                                    value: newVal,
                                                };
                                                return newArr;
                                            });
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            {/* footer */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    'Lưu lại',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogEditSettingView;
